// extracted by mini-css-extract-plugin
export default {"optionName":"MQ7MPm_B"};